module.exports = __webpack_public_path__ + "img/LBC-alt.8a4d00dd.svg";